import './Request.scss';
import Component from './Request.js';
export default Component;
